import { render, staticRenderFns } from "./CompanySignupWizard.vue?vue&type=template&id=70279aa4&scoped=true"
import script from "./CompanySignupWizard.vue?vue&type=script&lang=js"
export * from "./CompanySignupWizard.vue?vue&type=script&lang=js"
import style0 from "./CompanySignupWizard.vue?vue&type=style&index=0&id=70279aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70279aa4",
  null
  
)

export default component.exports